<template>
	<!-- content works -->
	<div class="landing-works">
			
		<section  class="container-fluid">
			<div class="text-center headline-container">
				<h1 class="headline">Join us. Let's do the impossible together.</h1>
			</div>
		</section>

		<!-- Jobs Opening -->
		<section id="job-openings" class="container job-openings">
			<h2>Job Openings</h2>
			
			<!-- <iframe name="resumator-job-frame" id="resumator-job-frame" class="resumator-advanced-widget" src="//marcusthomas.applytojob.com/apply/jobs/" width="100%" scrolling="yes" frameborder="0" allowTransparency="true"></iframe> -->
		</section>
		
	</div>
</template>

<script>
import apiConnection from '../mixins/apiConnection.js';
import seoModule from '../mixins/seoModule.js';
import boxesWrapper from '../components/boxes-wrapper.vue';
import dropdown from 'vue-my-dropdown';
import postscribe from 'postscribe';
require('../assets/img/search-icon.svg');
require('../assets/img/select-down.svg');

export default{
	name:'Jobs',
	data () {
		return {
			works: [],
			pageWork:[],
			showSelect:false,
			taxonomySolutions:[],
			// taxonomyMarkets:[],
			search:'',
			position: [ "left", "bottom", "left", "top" ],
			modularContent: []
		}
	},
	created:function(){

		window.addEventListener('resize', this.handleResize);
	},
	components:{
		'boxes-wrapper':boxesWrapper,
		dropdown
	},
	mixins:[apiConnection,seoModule],
	methods:{
		handleResize:function(){
			if(!this.$breakpoints.isMobile()) {
				this.showSelect = true;
			}
		}
	},
	mounted () {
		this.$gtm.trackView('Works Landing', 'Works');
		setTimeout(function(){
		    $('.st-sticky-share-buttons').removeClass('st-sticky-share-buttons-show')
		},500);


		// window.addEventListener("load", function(event) {
		// 	let scriptEl = document.createElement('script');
		// 			scriptEl.setAttribute('src', 'https://app.jazz.co/widgets/basic/create/marcusthomas');
		// 			scriptEl.setAttribute('type', 'text/javascript');
		// 			scriptEl.async = true;
		// 			scriptEl.setAttribute('charset', 'utf-8');
		// 			this.document.getElementById('job-openings').appendChild(scriptEl);
		// });

		window.addEventListener("hashchange", function () {
			var x = location.hash.substr(1);;
			if (window.screen.width <= 768) {
				document.getElementById(x).scrollIntoView({block: "start", behavior: "smooth"});
			}
			else {
				document.getElementById(x).scrollIntoView({block: "end", behavior: "smooth"});
			}
		});

		postscribe('#job-openings',`<div id="rr-job-board" data-job-board-id="marcus-thomas-careers"><\/div><script src="https://static-assets.ripplingcdn.com/ats/embeds/job-board.v1.js" async><\/script>`);

		//postscribe('#job-openings', `<script src="https://app.jazz.co/widgets/basic/create/marcusthomas"><\/script>`)
	},
}
</script>


// WEBPACK FOOTER //
// JobsPage.vue?8a445e44